<script setup lang="ts">
const props = defineProps({
	class: {
		type: String,
		default: '',
		required: false,
	},
});
</script>

<template>
	<section :class="[props.class]">
		<slot />
	</section>
</template>
